(() => {
  class SweetSpacesVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');

      if (!this.video || !this.toggle) {
        return;
      }

      this.videoLabel = this.dataset.videoLabel || 'video';
      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onToggleClick = this.onToggleClick.bind(this);
      this.onVideoPlay = () => this.syncState(true);
      this.onVideoPause = () => this.syncState(false);

      this.toggle.addEventListener('click', this.onToggleClick);
      this.video.addEventListener('play', this.onVideoPlay);
      this.video.addEventListener('pause', this.onVideoPause);

      const shouldAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotionQuery.matches;

      if (shouldAutoplay) {
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => this.syncState(false));
        }
      } else {
        this.syncState(false);
      }
    }

    disconnectedCallback() {
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.onToggleClick);
      }
      if (this.video) {
        this.video.removeEventListener('play', this.onVideoPlay);
        this.video.removeEventListener('pause', this.onVideoPause);
      }
    }

    onToggleClick() {
      if (this.video.paused) {
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else {
        this.video.pause();
      }
    }

    syncState(isPlaying) {
      this.classList.toggle('is-playing', isPlaying);
      this.toggle.setAttribute('aria-pressed', String(isPlaying));
      this.toggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${this.videoLabel}`);
    }
  }

  if (!customElements.get('sweet-spaces-video')) {
    customElements.define('sweet-spaces-video', SweetSpacesVideo);
  }
})();
